export const SAVE_ROLE = 'SAVE_ROLE'
